import { Box, Skeleton, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import Link from 'next/link';
import Marquee from 'react-fast-marquee';
import { getLandingPageGroups } from 'src/logic/services/catalogue/classification';
import { sm } from 'src/site-map';
import PrimaryButton from '../components/buttons/PrimaryButton';

const sliceGroupName = (name: string, LENGTH = 40) => {
  if (name.length < LENGTH) return name;
  return `${name.slice(0, LENGTH)}...`;
};

const CategoriesSliderAsCards = () => {
  const { data } = useQuery({
    queryKey: ['LANDING_PAGE_GROUPS'],
    queryFn: async () => {
      const { data } = await getLandingPageGroups();
      return data.items;
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: 1,
  });

  return (
    <div style={{ paddingBlock: '4rem' }}>
      <Typography
        textAlign={'center'}
        px={1}
        fontSize={{ xs: 26, lg: 44 }}
        fontWeight={600}
        color='#070A0D'
        maxWidth={'730px'}
        mx='auto'
        lineHeight={1}
        component='h3'
      >
        One platform - <span style={{ color: '#005FCC' }}>Any industry</span>
      </Typography>

      <Typography
        color='#3C434A'
        lineHeight={1.5}
        fontSize={{ xs: 12, lg: 16 }}
        fontWeight={400}
        textAlign={'center'}
        maxWidth={'500px'}
        mx={'auto'}
        my={4}
        px={1}
      >
        Designed to support procurement needs in all sectors — from manufacturing to services
      </Typography>

      <div>
        {data ? (
          <Marquee
            autoFill
            pauseOnHover
            style={{
              overflow: 'hidden',
              paddingBlock: '2rem',
            }}
          >
            {data.map(group => (
              <Box
                key={group.id}
                mr={4}
                minHeight={'130px'}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'space-around'}
                flexDirection={'column'}
                gap={'0.5rem'}
                width='250px'
                sx={{
                  backgroundColor: '#fff',
                  boxShadow: '0px 0px 40px 0px #0017721A',
                  borderRadius: '20px',
                  p: 2,
                }}
              >
                <div
                  style={{
                    width: '44px',
                    height: '44px',
                  }}
                >
                  {group.image_url ? (
                    <img src={group.image_url} alt={group.name} width={'44px'} height={'44px'} />
                  ) : null}
                </div>
                <Typography
                  textAlign={'center'}
                  color='#3C434A'
                  fontWeight={400}
                  fontSize={{ xs: 12, lg: 16 }}
                  lineHeight={1.4}
                >
                  {sliceGroupName(group.name)}
                </Typography>
              </Box>
            ))}
          </Marquee>
        ) : (
          <Marquee autoFill pauseOnHover style={{ overflow: 'hidden' }}>
            <Skeleton variant='rectangular' width='250' height={130} sx={{ borderRadius: '20px', mr: 4 }} />
          </Marquee>
        )}
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '1rem' }}>
        <Link href={sm.register.index.url} passHref>
          <PrimaryButton sx={{ px: 8 }}>Get Started</PrimaryButton>
        </Link>
      </div>
    </div>
  );
};

export default CategoriesSliderAsCards;
